import React, { useState, useEffect } from 'react';
import './Sidebar.css';
import './Buttons.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faChevronDown, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import api from '../api';

const SidebarRight = ({
    currentGardener,
    plants = [],
    userPlantData = [],
    isLoggedIn,
    onSelectVariety,
    selectedVariety,
    onSelectCrop,
    selectedCrop,
    handleAddPlant,
    handleRemovePlant,
    handleTryDemo,
    handleCancelDemo,
    isDemoMode,
    handleTabChange,
    onOpenHelp,
    isLockedOutMode
}) => {
    const [showCropSelect, setShowCropSelect] = useState(false);
    const [expandedCropId, setExpandedCropId] = useState(null);
    const [pendingRemovalCropId, setPendingRemovalCropId] = useState(null);
    const [allPlants, setAllPlants] = useState([]);

    const viewCrop = (cropId) => {
        onSelectCrop(cropId);
        onSelectVariety(null);
        handleTabChange('Crop Profile');
    };

const toggleCrop = (cropId) => {
    if (currentGardener?.isNewUser || isLockedOutMode) return;

    console.log(
        'selectedCrop:', selectedCrop,
        'expandedCropId:', expandedCropId,
        'crop clicked:', cropId
    );

    const isExpanded = expandedCropId === cropId;

    if (isExpanded) {
        // Collapse only. Keep the crop selected.
        setExpandedCropId(null);
        onSelectVariety(null);
        handleTabChange('Crop Profile');
    } else {
        // Expand this crop and select it.
        setExpandedCropId(cropId);
        onSelectCrop(cropId);
        onSelectVariety(null);
        handleTabChange('Crop Profile');
    }
};

useEffect(() => {
  const fetchAllPlants = async () => {
    try {
      const response = await api.get('/plants/all');

      // Optional: Validate content type if needed
      const contentType = response.headers['content-type'];
      if (!contentType || !contentType.includes('application/json')) {
        throw new TypeError(`Expected JSON response, but received: ${contentType}`);
      }

      const data = response.data;
      setAllPlants(data);
    } catch (err) {
      console.error('Error fetching all plants:', err);
    }
  };

  fetchAllPlants();
}, []);

    const gardenerCropIDs = plants.map(p => p.id); 
    const availablePlants = allPlants.filter(p => !gardenerCropIDs.includes(p.plantID));

    return (
        <div className="sidebar-right">
            {!isLoggedIn || !currentGardener ? (
                <div>
                    <h2>HOW DO I START</h2>
                    <p>1. Click Get Started to tell us what you eat and where you grow.</p>
                    <p>2. We will match you with plants that thrive in your location.</p>
                    <p>3. You will get a seasonal planting calendar and seasonal gardening tasks.</p>
                    <h4>Sit back and let the app guide your gardening journey!</h4>
                </div>
            ) : (
                <div className="current-gardener">

                        {/* DEMO GARDEN BUBBLE */}
                        {/*   {!isDemoMode && (
                        <div 
                            className="sidebar-demo-bubble"
                                onClick={handleTryDemo}
                            title="Jordan has gardening tasks every month of the year � see what she is growing now."
                        >
                            <div className="demo-title">Explore Demo Gardener</div>
                            <div className="demo-subline">See what is growing this month</div>                        </div>
                    )}*/}
                        {/* DEMO GARDEN BUBBLE */}
                        {!isDemoMode && (
                            <div
                                className="sidebar-demo-bubble"
                                onClick={() => window.open("https://live.zohocloud.ca/mmbi-ayx-maw")}
                            title="Join our live GrowYourFoodApp overview webinar!"
                        >
                            <div className="demo-title">Webinar Registration</div>
                            <div className="demo-subline">Live GrowYourFoodApp Overview Session</div>                        </div>
                    )}

                    {/* When IN demo mode, show a compact exit bubble */}
                    {isDemoMode && (
                        <div className="sidebar-demo-bubble demo-active">
                            <div className="demo-active-text">
                                Demo Garden Mode
                            </div>
                            <button 
                                className="button small" 
                                onClick={handleCancelDemo}
                            >
                                Exit Demo
                            </button>
                        </div>
                    )}

                    {/* Gardener Info */}
                    <h2>Gardener Profile</h2>
                        <div className="gardener-info">
                            <div className="gardener-row">
                                <strong>{currentGardener.name || ''}</strong>
                            </div>

                            <div className="gardener-row">
                                {currentGardener.experienceLevel || ''} - {currentGardener.city || ''}, {currentGardener.province || ''}
                            </div>
                            <div className="gardener-row">
                                {currentGardener.email || ''}
                            </div>

                            <div className="gardener-row">
                                Family Size: {currentGardener.familysize || ''}
                            </div>
                            <button 
                                className="button small profile-manage-btn"
                                onClick={() => handleTabChange('Gardener')}
                                disabled={isDemoMode || isLockedOutMode}
                            >
                                Manage Profile
                            </button>
                        </div>
                        <div className="section-spacer" />
                    {/* Crop Tabs */}
                    <h2>Your Crop List</h2>

                    {/* Add Crop Tab */}
                        {/*         <div
                            className={`crop-tab add-crop ${(isDemoMode || isLockedOutMode) ? 'disabled' : ''}`}
                              onClick={() => {
                                  if (isDemoMode || isLockedOutMode || currentGardener?.isNewUser) return;

                                // 1) Open the crop selector
                                setShowCropSelect(prev => !prev);

                                // 2) Immediately switch to My Plants tab
                                  //handleTabChange('My Plants');
                                  handleTabChange('Crop Profile');
                              }}
                            >
                            <FontAwesomeIcon icon={faPlus} className="plus-icon" />
                            <span>Add Crop</span>
                        </div> 
                        {isDemoMode && <p className="demo-hint">Adding crops is disabled, your trial period has ended.</p>}
                        {isLockedOutMode && <p className="demo-hint">Adding crops is disabled in demo mode.</p>}
                        {showCropSelect && (
                            <div className="crop-selector">
                                <label htmlFor="plant">Select a new crop to add:</label>
                                <select
                                    name="plantID"
                                    id="plant"
                                    onChange={(e) => {
                                        const selectedID = parseInt(e.target.value);
                                        const selectedPlant = availablePlants.find(p => p.plantID === selectedID);
                                        if (selectedPlant) {
                                            handleAddPlant({ plantID: selectedPlant.plantID }); //  add immediately
                                            toggleCrop(selectedPlant.plantID)
                                            setShowCropSelect(false);                      // close dropdown
                                        }
                                    }}
                                >
                                    <option value="">-- Choose a new crop --</option>
                                    {availablePlants.map((plant) => (
                                        <option key={plant.plantID} value={plant.plantID}>
                                            {plant.name}
                                        </option>
                                    ))}
                                </select>
                            </div> 
                        )} */}
                       
                    <div className="crop-tabs">
                        {plants.map((plant) => {
                            const varieties = userPlantData.filter((data) => data.plantID === plant.id);
                            const isExpanded = expandedCropId === plant.id;
                            return (
                                <div key={plant.id} className="crop-tab">
                                    <div
                                        className="crop-tab-header"
                                        onClick={() => toggleCrop(plant.id)}
                                    >
                                        <div className="crop-header-left">
                                            <strong>{plant.name}</strong>

                                            <div className="variety-line">
                                            <span className="variety-count">
                                                {varieties.length === 1
                                                    ? '1 variety - tap to manage'
                                                    : `${varieties.length} varieties - tap to manage`}
                                            </span>

                                        <FontAwesomeIcon
                                            icon={isExpanded ? faChevronDown  : faChevronRight}
                                            className="variety-chevron"
                                            />
                                            </div>
                                        </div>
                                    </div>

                                    {isExpanded && (
                                        <div className="variety-tab-list">
                                            {varieties.length === 0 ? (
                                                <div className="no-varieties">No varieties added yet.</div>
                                            ) : (
                                                varieties.map((variety, index) => (
                                                    <div
                                                        key={index}
                                                        className="variety-tab"
                                                        onClick={() => onSelectVariety(variety)}
                                                    >
                                                        <strong>{variety.variety || 'Unnamed Variety'}</strong>
                                                        {variety.notes && (
                                                            <div className="variety-notes">{variety.notes}</div>
                                                        )}
                                                    </div>
                                                ))
                                            )}

                                            {/* Add Variety Button */}
                                            <button
                                                className="add-variety-button"
                                                onClick={() => {
                                                    onSelectCrop(plant.id);
                                                    onSelectVariety({isNewVariety:true});
                                                }}
                                                disabled={isDemoMode || isLockedOutMode}
                                            >
                                                <FontAwesomeIcon icon={faPlus} className="plus-icon" />
                                                Add Variety
                                            </button>
                                            <button
                                                className="remove-crop-button"
                                                onClick={() => {
                                                    if (varieties.length > 0) {
                                                        setPendingRemovalCropId(plant.id);
                                                    } else {
                                                        handleRemovePlant(plant.id);
                                                        setPendingRemovalCropId(null);
                                                    }
                                                }}
                                                disabled={isDemoMode || isLockedOutMode}
                                            >
                                                Remove Crop
                                            </button>
                                            {pendingRemovalCropId === plant.id && varieties.length > 0 && (
                                                <div className="remove-warning">
                                                    Remove all varieties before deleting this crop.
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                        </div>

                        <div className="section-spacer" />

                        <h2>Crop Library</h2>

                        <div className="all-crops-list">
                            {availablePlants.map((plant) => (
                                <div
                                    key={plant.plantID}
                                    className="crop-tab available-crop"
                                    onClick={() => {
                                        if (isDemoMode || isLockedOutMode || currentGardener?.isNewUser) return;

                                        // Add crop to gardener
                                       // handleAddPlant({ plantID: plant.plantID }); 

                                        // Expand it immediately
                                        viewCrop(plant.plantID);
                                    }}
                                >
                                    <FontAwesomeIcon icon={faChevronRight} className="variety-chevron" />
                                    <span>{plant.name}</span>
                                </div>
                            ))}
                        </div> 


                </div>
            )}

            <div className="section-spacer" />

            <div className="sidebar-footer-links">
                <button 
                    className="sidebar-link-button" 
                    onClick={onOpenHelp}
                >
                    FAQ
                </button>

                <button 
                    className="sidebar-link-button" 
                    onClick={() => handleTabChange('About')}
                >
                    About
                </button>
            </div>


        </div>
    );
};

export default React.memo(SidebarRight);
